import React, { Fragment, useState, useEffect } from 'react';
import {
  CCol,
  CDataTable,
  CFormGroup,
  CLabel,
  CRow,
  CSelect,
} from '@coreui/react';
import SpinnerWithContainer from '../components/SpinnerWithContainer';
import VoteService from '../services/votes.service';
import CategoryService from '../services/categories.service';

const fields = [
  { key: 'selectedBrand', label: 'Selected Brand' },
  { key: 'otherBrand', label: 'Other Brand' },
  { key: 'category', label: 'Category' },
  { key: 'rating', label: 'Rating' },
  { key: 'review', label: 'Review' },

  // {
  //     key: "options",
  //     label: "Options",
  //     sorter: false,
  //     filter: false,
  // },
];

const VoteAndFeedbacks = () => {
  // component state
  const [isloading, setIsloading] = useState({
    get: false,
    delete: false,
    add: false,
  });
  const [feedbacks, setFeedbacks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [currentCategory, setCurrentCategory] = useState('all');
  const [filteredFeedbacks, setFilteredFeedbacks] = useState([]);

  // useEffect to fetch feedbacks
  useEffect(() => {
    getFeedbacks();
  }, []);

  // effect for filtering feedbacks
  useEffect(() => {
    if (currentCategory === 'all') return;

    const filteredFeedbacks = feedbacks.filter(
      (feedback) => feedback.selection.categories[0]._id === currentCategory
    );

    setFilteredFeedbacks(filteredFeedbacks);
  }, [currentCategory]);

  const mapFeedbacks = (data) => {
    return data.map((item) => ({
      selectedBrand: item.brands.filter(
        (brand) => brand._id === item.selection?._id
      )[0].name,
      otherBrand: item.brands.filter(
        (brand) => brand._id !== item.selection?._id
      )[0].name,

      category: item.selection?.categories[0].name,

      rating:
        item.feedback && item.feedback.rating && item.feedback.rating !== null
          ? item.feedback.rating
          : '',
      review:
        item.feedback && item.feedback.review && item.feedback.review !== null
          ? item.feedback.review
          : '',
    }));
  };

  const getFeedbacks = async () => {
    setIsloading({ ...isloading, get: true });
    try {
      const res = await VoteService.get();

      const { data } = await CategoryService.get();
      setCategories(data);

      setFeedbacks(res.data);
      setIsloading({ ...isloading, get: false });
    } catch (e) {
      setIsloading({ ...isloading, get: false });
      console.log('er', e);
    }
  };

  const renderFeedbacks = () => {
    return mapFeedbacks(
      currentCategory === 'all' ? feedbacks : filteredFeedbacks
    );
  };

  return (
    <Fragment>
      <h1>Votes & Feedbacks</h1>

      <Fragment>
        {isloading.get ? (
          <SpinnerWithContainer />
        ) : (
          <Fragment>
            <CRow>
              <CCol lg="6">
                <CFormGroup inline>
                  <CLabel>Brand categories</CLabel>
                  <CSelect
                    name="categories"
                    value={currentCategory}
                    onChange={(evt) => setCurrentCategory(evt.target.value)}
                  >
                    <option value="all">All categories</option>
                    {categories.map((category) => (
                      <option key={category._id} value={category._id}>
                        {category.name}
                      </option>
                    ))}
                  </CSelect>
                </CFormGroup>
              </CCol>
            </CRow>

            <CDataTable
              fields={fields}
              // itemsPerPage={"5"}
              items={renderFeedbacks()}
              tableFilter
              responsive

              // scopedSlots={{
              //     selectedBrand: (item, index) => {
              //         // console.log(item);
              //         return (
              //             <td>
              //                 {item.brands.filter(brand => brand._id === item.selection)[0].name}
              //             </td>)
              //     },
              //     otherBrand: (item, index) => {
              //         return (
              //             <td>
              //                 {item.brands.filter(brand => brand._id != item.selection)[0].name}
              //             </td>)
              //     },
              //     rating: (item, index) => {
              //         return (<td>{item.feedback && item.feedback.rating}</td>)
              //     },
              //     review: (item, index) => {
              //         return (<td>{item.feedback && item.feedback.review}</td>)
              //     },

              // }}
            />
          </Fragment>
        )}
      </Fragment>
    </Fragment>
  );
};

export default VoteAndFeedbacks;
